module.exports = __webpack_public_path__ + "img/second-day-10.a44b9365.png";